const isProduction = process.env.NODE_ENV === 'production';

const API_URL = isProduction
	? process.env.REACT_APP_DEPLOYED_API_URL
	: process.env.REACT_APP_DEVELOPMENT_API_URL;

const ORIGINAL_STOCK_IMAGE_URL = isProduction
	? process.env.REACT_APP_DEPLOYED_STOCK_IMAGES_ORIGINAL_URL
	: process.env.REACT_APP_DEVELOPMENT_STOCK_IMAGES_ORIGINAL_URL;

const COMPRESSED_STOCK_IMAGE_URL = isProduction
	? process.env.REACT_APP_DEPLOYED_STOCK_IMAGES_COMPRESSED_URL
	: process.env.REACT_APP_DEVELOPMENT_STOCK_IMAGES_COMPRESSED_URL;

const token = JSON.parse(localStorage.getItem('token'));

const config = {
	headers: {
		'Content-type': 'application/json',
		Authorization: token,
	},
};

const formConfig = {
	headers: {
		'Content-Type': 'multipart/form-data',
		Authorization: token,
	},
};

module.exports = {
	API_URL,
	config,
	ORIGINAL_STOCK_IMAGE_URL,
	COMPRESSED_STOCK_IMAGE_URL,
	formConfig,
};
